import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { Filosofia_Corporativa } from '../../../models/Formulacion/indicadores-metas/datos';

@Injectable({
  providedIn: 'root'
})
export class FilosofiaService {
  private apiURL = environment.apiURL_institucion;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  constructor(
    private http: HttpClient,
    private cookies: CookieService,
  ) {}

  public getFilosofia(): Observable<any> {
    const apiURL = `${this.apiURL}filosofia`;
    return this.http.get(`${apiURL}`, { headers: this.headers });
  }

  public postfilosofia(concept: any): Observable<any> {
    const filo: Filosofia_Corporativa = {
      name: concept.name,
      description: concept.description,
      planningId: Number(concept.planningId),
    }
    const body = JSON.stringify(filo);
    const apiURL = `${this.apiURL}filosofia`;
    return this.http.post(`${apiURL}`, body, { headers: this.headers });
  }

  public patchfilosofia(concept: any): Observable<any> {
    const filo: Filosofia_Corporativa = {
      name: concept.name,
      description: concept.description,
      planningId: Number(concept.planningId),
    }
    const body = JSON.stringify(filo);
    const apiURL = `${this.apiURL}filosofia/${concept.id}`;
    return this.http.patch(`${apiURL}`, body, { headers: this.headers });
  }
  
  public deletefil(per): Observable<any> {
    const apiURL = `${this.apiURL}filosofia/${per.id}`;
    return this.http.delete(`${apiURL}`, { headers: this.headers });
  }
}
